import { Component, computed, inject } from "@angular/core"
import { RouterLink } from "@angular/router"
import { AppRoute } from "../../types/appRoute"
import { RouteService } from "../../services/route.service"
import { AuthenticationService } from "@app/services/authentication/authentication.service"
import { Option } from "@app/types/option"

@Component({
    selector: 'vco-header',
    imports: [RouterLink],
    template: `
        <div class="tab" [routerLink]="purchasingCoOp()"
            [class.active-tab]="active().purchasingCoOp">
            Purchasing Co Op
        </div>
        @if (isGlobalAdmin()) {
            <div class="tab" [routerLink]="membership()"
                [class.active-tab]="active().membership">
                Membership
            </div>
        }
    `,
    styles: [`
        :host {
            display: flex;
            gap: .5rem;            
        }
    `]
}) export class HeaderComponent {
    private readonly _routeService = inject(RouteService)
    private readonly _route = this._routeService.currentRoute

    private readonly _authenticationService = inject(AuthenticationService)
    private readonly _user = this._authenticationService.authenticatedUser
    readonly isGlobalAdmin = computed(() => Option.orUndefined(this._user())?.role === 'GlobalAdmin')

    readonly active = computed(() => ({
        purchasingCoOp: this._route().purchasingCoOp,
        membership: this._route().membership
    }))
    readonly purchasingCoOp = computed(() => this.active().purchasingCoOp ? undefined : AppRoute.create(['purchasingCoOp']))
    readonly membership = computed(() => this.active().membership ? undefined : AppRoute.create(['membership']))
}